import { render, staticRenderFns } from "./PDICSModal.vue?vue&type=template&id=8a8758dc&scoped=true"
import script from "./PDICSModal.vue?vue&type=script&lang=js"
export * from "./PDICSModal.vue?vue&type=script&lang=js"
import style0 from "./PDICSModal.vue?vue&type=style&index=0&id=8a8758dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8758dc",
  null
  
)

export default component.exports